export default class CandidateShiftRecordJsonExtraData {
  constructor(data = {}) {
    this.noRestBreaks = data.noRestBreaks || null // Reason for missing rest breaks
    this.mealReduced = data.mealReduced || null // Indicates if a meal break was reduced
    this.durationIncreased = data.durationIncreased || null // Indicates if the shift was extended
    this.didNotHappen = data.didNotHappen || null // Indicates if the shift did not happen
  }
}
